import convert from "convert-units";
import { coins_units, units_1, units_8 } from "../constants.js";
import { convertUnits } from "./convert.js";

//Codigos que se ven en los formularios
export const effluentCodes = {
  domestic_effluents: "Efl1",
  industrial_effluents: "Efl2",
  combined_effluents: "Efl3",
  sludge_and_mud: "Efl4",
  recycled_effluents: "Efl5",
  treatment_cost_domestic_effluents: "Efl6",
  industrial_effluent_treatment_cost: "Efl7",
  combined_treatment_cost: "Efl8",
  sludge_treatment_cost: "Efl9",
};

//Codigos de los indicadores que se ven en el dashboard
export const effluentKPIsCodes = {
  total_domestic_effluents_kpis: "KPIefl1",
  total_industrial_effluents_kpis: "KPIefl2",
  total_combined_effluents_kpis: "KPIefl3",
  domestic_effluents_kpis: "KPIefl4",
  industrial_effluents_kpis: "KPIefl5",
  //combined_effluents_kpis: "KPIefl6",
  sludge_and_mud_kpis: "KPIefl6",
  recycled_effluents_kpis: "KPIefl7",
  treatment_cost_domestic_effluents_kpis: "KPIefl8",
  industrial_effluent_treatment_cost_kpis: "KPIefl9",
  sludge_disposal_cost_kpis: "KPIefl10",
};

//En base al valor del campo / key devuelve el valor correspondiente de acuerdo al año es de tipo {total, unit}
export function effluentFormulasIndicators(field, year, data, baseline, cantW, workersTotals) {
  switch (field) {
    
    
    case "total_domestic_effluents_kpis":
      return {
        
        
        total: data["domestic_effluents"]?.[year].total,
        unit: data["domestic_effluents"]?.[year].unit,
      };
    case "total_industrial_effluents_kpis":
      return {
        total: data["industrial_effluents"]?.[year].total,
        unit: data["industrial_effluents"]?.[year].unit,
      };
    case "total_combined_effluents_kpis":
      return {
        total: data["combined_effluents"]?.[year].total,
        unit: data["combined_effluents"]?.[year].unit,
      };
    case "domestic_effluents_kpis":
      return {
        total: data["domestic_effluents"]?.[year].total / cantW,
        unit: data["domestic_effluents"]?.[year].unit,
      };
    case "industrial_effluents_kpis":
      return {
        total: data["industrial_effluents"]?.[year].total / baseline,
        unit: data["industrial_effluents"]?.[year].unit,
      };

      case "combined_effluents_kpis":
    return {
      total: data["combined_effluents"]?.[year].total /baseline,
      unit: data["combined_effluents"]?.[year].unit,
    };
    case "sludge_and_mud_kpis":
      return {
        total: data["sludge_and_mud"]?.[year].total / baseline,
        unit: data["sludge_and_mud"]?.[year].unit,
      };

    case "treatment_cost_domestic_effluents_kpis":
      return {
        total: data["treatment_cost_domestic_effluents"]?.[year].total / cantW,
        unit: data["treatment_cost_domestic_effluents"]?.[year].unit,
      };
    case "industrial_effluent_treatment_cost_kpis":
      return {
        total:
          data["industrial_effluent_treatment_cost"]?.[year].total / baseline,
        unit: data["industrial_effluent_treatment_cost"]?.[year].unit,
      };

    case "recycled_effluents_kpis":
      return {
        total: data["recycled_effluents"]?.[year].total / baseline,
        unit: data["recycled_effluents"]?.[year].unit,
      };
    case "sludge_disposal_cost_kpis":
      return {
        total: data["sludge_treatment_cost"]?.[year].total / baseline,
        unit: data["sludge_treatment_cost"]?.[year].unit,
      };

    default:
      return false;
  }
}

//Determina las unidades utilizadas de acuerdo a cada campo/key ver boceto con unidades
export const determineEffluentUnits = (value) => {
  if (
    value === "domestic_effluents" ||
    value === "domestic_effluents_kpis" ||
        value === "total_domestic_effluents_kpis" ||
    value === "industrial_effluents" ||
    value === "industrial_effluents_kpis" ||
    value === "total_industrial_effluents_kpis" ||
    value === "combined_effluents_kpis" ||
    value === "combined_effluents" ||

     value === "total_combined_effluents_kpis" ||
    value === "total_effluent_kpis" ||
    value === "sludge_and_mud_kpis" ||
    value === "sludge_and_mud" ||
    value === "recycled_effluents" ||
    value === "recycled_effluents_kpis"
  )
    return units_8;
  else if (
    value === "sludge_treatment_cost_kpis" ||
    value === "sludge_treatment_cost" ||
    value === "total_effluent_treatment_kpis" ||
    value === "sludge_disposal_cost_kpis" ||
    value === "combined_treatment_cost_kpis" ||
    value === "combined_treatment_cost" ||
    value === "industrial_effluent_treatment_cost_kpis" ||
    value === "treatment_cost_domestic_effluents_kpis" ||
    value === "recycled_effluents_cost" ||
    value === "treatment_cost_domestic_effluents" ||
    value === "industrial_effluent_treatment_cost"
  ) {
    return coins_units;
  } else {
    return units_1;
  }
};

// export function convertUnitsEffluent(
//   valor,
//   unidadOrigen,
//   unidadDestino,
//   densidad = null,
//   unidadDensidad = null
// ) {
//   // Definir las conversiones de masa
//   const conversionesMasa = {
//     g: 1,
//     kg: 1000,
//     ton: 1000000,
//   };

//   // Definir las conversiones de volumen
//   const conversionesVolumen = {
//     l: 1,
//     m3: 1000, // 1 m³ = 1000 L
//     galon: 3.78541, // 1 gal (EE.UU.) = 3.78541 L
//     galImperial: 4.54609, // 1 gal (imperial) = 4.54609 L
//   };

//   // Convertir densidad a g/cm³ si es necesario
//   const convertirDensidadAGramosPorCm3 = (densidad, unidadDensidad) => {
//     switch (unidadDensidad) {
//       case "kg/m3":
//         return densidad / 1000; // Convertir kg/m³ a g/cm³
//       case "ton/m3":
//         return densidad * 1000; // Convertir ton/m³ a g/cm³
//       case "g/cm3":
//         return densidad; // Si ya es g/cm³, no hay conversión
//       default:
//         console.error("Unidad de densidad no soportada");
//         return NaN; // Retorna NaN si la unidad de densidad no es válida
//     }
//   };

//   // Verificar si estamos trabajando con masa
//   const esMasa = (unidad) => ["g", "kg", "ton"].includes(unidad);
//   // Verificar si estamos trabajando con volumen
//   const esVolumen = (unidad) =>
//     ["l", "m3", "galon", "galImperial"].includes(unidad);

//   // Si la densidad es necesaria y no está especificada, retornar NaN
//   if (densidad !== null && unidadDensidad !== null) {
//     densidad = convertirDensidadAGramosPorCm3(densidad, unidadDensidad);
//     if (isNaN(densidad)) return "Densidad no válida";
//   }

//   // Convertir entre masa y volumen (con densidad)
//   if (esMasa(unidadOrigen) && esVolumen(unidadDestino)) {
//     const valorEnGramos = valor * conversionesMasa[unidadOrigen];
//     const volumenEnCm3 = valorEnGramos / densidad; // Convertir masa a volumen en cm³
//     if (unidadDestino === "l") {
//       return volumenEnCm3 / 1000; // Convertir cm³ a litros
//     } else if (unidadDestino === "m3") {
//       return volumenEnCm3 / 1000000; // Convertir cm³ a m³
//     } else if (unidadDestino === "gal") {
//       return volumenEnCm3 / 1000 / 3.78541; // Convertir cm³ a galones (EE.UU.)
//     } else if (unidadDestino === "galImperial") {
//       return volumenEnCm3 / 1000 / 4.54609; // Convertir cm³ a galones (imperial)
//     }
//   }

//   if (esVolumen(unidadOrigen) && esMasa(unidadDestino)) {
//     const valorEnVolumen = valor * conversionesVolumen[unidadOrigen];
//     const masaEnGramos = valorEnVolumen * densidad * 1000; // Convertir volumen a masa en gramos
//     return masaEnGramos / conversionesMasa[unidadDestino];
//   }

//   // Si las unidades son de masa o volumen y son iguales
//   if (esMasa(unidadOrigen) && esMasa(unidadDestino)) {
//     const valorEnGramos = valor * conversionesMasa[unidadOrigen];
//     return valorEnGramos / conversionesMasa[unidadDestino];
//   }

//   if (esVolumen(unidadOrigen) && esVolumen(unidadDestino)) {
//     const valorEnVolumen = valor * conversionesVolumen[unidadOrigen];
//     return valorEnVolumen / conversionesVolumen[unidadDestino];
//   }

//   return "Conversión no válida";
// }

export function convertUnitsEffluent(valor, unidadOrigen, unidadDestino) {
  unidadOrigen = unidadOrigen?.toLowerCase?.() ?? unidadOrigen;
  unidadDestino = unidadDestino?.toLowerCase?.() ?? unidadDestino;
  const conversionesVolumen = {
    l: 1,
    m3: 1000, // 1 m³ = 1000 L
    galon: 3.78541, // 1 gal (EE.UU.) = 3.78541 L
    galImperial: 4.54609, // 1 gal (imperial) = 4.54609 L
  };

  // Verificar unidades válidas
  if (
    !(unidadOrigen in conversionesVolumen) ||
    !(unidadDestino in conversionesVolumen)
  ) {
    return "Conversión no válida (solo volumen)";
  }

  // Convertir todo a litros y luego a la unidad destino
  const valorEnLitros = valor * conversionesVolumen[unidadOrigen];
  return valorEnLitros / conversionesVolumen[unidadDestino];
}

export const densidades = {
  // "water": 1.00,  // 1 g/cm³ (1000 kg/m³)
  // "iron": 7.87,  // 7.87 g/cm³
  // "wood": 0.60,  // 0.60 - 1.00 g/cm³
  // "glass": 2.50,  // 2.50 g/cm³
  // "oil": 0.92,  // 0.92 g/cm³
  // "ethanol": 0.79,  // 0.79 g/cm³
  // "polyethylene": 0.92,  // 0.92 g/cm³
  // "biomassa":1,
  // "gasoline":0.74,
  // "biodiesel":1,
  // "diesel":0.84,
  paper_and_cardboard: {
    density: 0.8,
    unit_density: "g/cm3",
  }, // Promedio de papel y cartón
  // "plastic": 1.00,  // Promedio de plástico (tipo general)
  // "fabric_or_scraps": 0.80,  // Promedio de telas (puede variar mucho)
  // "metal": 8.00,  // Promedio de metales como acero o hierro
  // "food": 0.80,  // Promedio de restos de comida orgánica
  // "leather": 1.20,  // Promedio de cuero
  // "foam": 0.10,  // Promedio de espuma EVA
  // "empty_cans_or_containers_not_dangerous": 2.70,  // Promedio de latas (aluminio o acero)
  // "otros_residuos": 1.00  // Promedio de otros residuos no peligrosos
};

export const convertUnitsFinal = (value, unita, unitb, material = "") => {
  try {
    // Si no se pasa el material, por defecto la densidad es 1 (como agua)
    // let densidad = densidades[material]?.density || 1; // Si no existe en el JSON, usamos 1 (agua)
    // let unitDensity = densidades[material]?.unit_density || "g/cm3";

    const esMoneda = (unidad) =>
      coins_units.some((moneda) => moneda.value === unidad);

    // Si las unidades de origen y destino son iguales, no hacer conversión
    if (!value) {
      return 0;
    } else {
      if (unita === unitb) {
        return value;
      }

      // Si estamos trabajando con monedas, aplicamos la conversión de divisas
      if (esMoneda(unita) && esMoneda(unitb)) {
        // Lógica de conversión de monedas (puedes usar una API o tasas fijas)
        // const tasaDeCambio = obtenerTasaDeCambio(unita, unitb); // Esta función debe obtener la tasa de cambio
        // if (!tasaDeCambio) {
        //   console.error("No se pudo obtener la tasa de cambio.");
        //   return null; // Si no se puede obtener la tasa, retornar null
        ////}
        //return value * tasaDeCambio; // Multiplicamos el valor por la tasa de cambio
        return value;
      }
      const result = convert(value).from(unita).to(unitb);
      // Si la conversión falla y devuelve NaN, vamos a intentar con la función personalizada
      if (isNaN(result)) {
        //console.log('La librería convert-units no pudo realizar la conversión. Intentando con la función personalizada...');
        const result2 = convertUnitsEffluent(
          value,
          unita,
          unitb
          // densidad,
          // unitDensity
        );

        return result2;
        //return value;
      }
      return result;
    }
  } catch (error) {
    try {
      // let densidad = densidades[material]?.density || 1; // Si no existe en el JSON, usamos 1 (agua)
      // let unitDensity = densidades[material]?.unit_density || "g/cm3";
      const result2 = convertUnitsEffluent(
        value,
        unita,
        unitb
        // densidad,
        // unitDensity
      );

      return result2;
    } catch {
      // Si ocurre un error en la librería o en la función personalizada, lo capturamos
      console.error(`Error de conversión: ${error.message}`);
      return null; // Retornamos null si hay un error
    }
  }
};
